import { Cell, ColumnMeta, Row, flexRender } from '@tanstack/react-table'

export type ColumnMetaType<T> = ColumnMeta<T, unknown> & {
    style?: React.CSSProperties
    filter?: {
        label: string
        filterPortalId?: string
    }
}
interface Props<T> {
    row: Row<T>
    isLastRow: boolean
    rowClass?: string
    columnClass?: string
    renderSubComponent?: any
}

export function TableRow<T>(props: Props<T>) {
    const { row } = props

    const cells = row.getVisibleCells()

    return (
        <>
            <tr key={row.id} className={`border-b border-gray-300 ${props.rowClass}`}>
                {cells.map((cell) => (
                    <TableCell cell={cell} key={cell.id} columnClass={props.columnClass} />
                ))}
            </tr>

            {row.getIsExpanded() && (
                <tr>
                    <td colSpan={row.getVisibleCells().length}>{props.renderSubComponent({ row })}</td>
                </tr>
            )}
        </>
    )
}

function TableCell<T>(props: { cell: Cell<T, unknown>; columnClass?: string }) {
    const { cell, columnClass } = props

    return (
        <td
            key={cell.id}
            style={(cell.column.columnDef.meta as ColumnMetaType<T> | undefined)?.style}
            className={`text-base text-black text-left max-tablet:text-sm  ${columnClass}`}
        >
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </td>
    )
}
